import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { WithIntlProps, WrappedComponentProps } from 'react-intl';

export const LinkToThisPageDialog: LoadableType<WithIntlProps<WrappedComponentProps<'intl'>>> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LinkToThisPageDialog" */ './LinkToThisPageDialog.js'
				)
			).LinkToThisPageDialog,
	});
